import { render } from "./WithdrawPopup.vue?vue&type=template&id=563013a5&scoped=true&ts=true"
import script from "./WithdrawPopup.vue?vue&type=script&lang=ts"
export * from "./WithdrawPopup.vue?vue&type=script&lang=ts"

import "./WithdrawPopup.vue?vue&type=style&index=0&id=563013a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563013a5"]])

export default __exports__